"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEntry = exports.withDefaultOptions = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var RegistryError_1 = require("../../errors/RegistryError");
var libraries_1 = require("../../libraries");
var createResourceLoader_1 = require("../../loaders/createResourceLoader");
var createEagerEntry_1 = require("./createEagerEntry");
var createLazyEntry_1 = require("./createLazyEntry");
var DEFAULT_MODE = 'lazy';
function getRegistryRuntime(_a) {
    var manifests = _a.manifests;
    var shouldReturnRuntime = manifests.every(function (manifest) {
        return libraries_1.isRegistryManifestContext(manifest);
    });
    return shouldReturnRuntime
        ? {
            libraries: manifests,
        }
        : null;
}
function withDefaultOptions(options) {
    return __assign({ dev: false, useNewManifest: true, shouldLoadCSSAssets: false, useScriptsInsteadOfEval: false }, options);
}
exports.withDefaultOptions = withDefaultOptions;
function createEntry(_a) {
    var _this = this;
    var host = _a.host, _b = _a.libraryAssetsPatterns, libraryAssetsPatterns = _b === void 0 ? [] : _b;
    return function (params) { return __awaiter(_this, void 0, void 0, function () {
        var libraries, transport, shouldLoadCSSAssets, useScriptsInsteadOfEval, options, resourceLoader_1, manifests, contexts, bundleLoaders_1, getModeByNamespace_1, eagerContexts, lazyContexts, runLazyRegistry, runEagerRegistry, e_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    libraries = params.libraries, transport = params.transport, shouldLoadCSSAssets = params.shouldLoadCSSAssets, useScriptsInsteadOfEval = params.useScriptsInsteadOfEval;
                    options = withDefaultOptions(__assign({ shouldLoadCSSAssets: shouldLoadCSSAssets,
                        useScriptsInsteadOfEval: useScriptsInsteadOfEval }, (params.options || {})));
                    if (!libraries || !libraries.length) {
                        throw RegistryError_1.createException('"libraries" is required property to create the registry', RegistryError_1.RegistryErrorCode.IncorrectEntryArguments);
                    }
                    if (!params.registerComponent && !params.registerLibrary) {
                        throw RegistryError_1.createException('"registerComponent" or "registerLibrary" should be passed to the registry', RegistryError_1.RegistryErrorCode.IncorrectEntryArguments);
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    resourceLoader_1 = createResourceLoader_1.createResourceLoader({
                        useScriptsInsteadOfEval: options.useScriptsInsteadOfEval,
                        transport: transport,
                        shouldLoadCSSAssets: options.shouldLoadCSSAssets,
                        globals: params.globals,
                    });
                    return [4 /*yield*/, libraries_1.loadLibrariesManifests({
                            host: host,
                            resourceLoader: resourceLoader_1,
                            libraries: libraries,
                            options: options,
                        })];
                case 2:
                    manifests = _a.sent();
                    contexts = libraries_1.parseManifests({
                        host: host,
                        manifests: manifests,
                        libraryAssetsPatterns: libraryAssetsPatterns,
                    });
                    bundleLoaders_1 = {};
                    contexts.forEach(function (_a) {
                        var library = _a.library;
                        bundleLoaders_1[library.artifactId] = resourceLoader_1.createBundleLoader({
                            environment: library.environment,
                        });
                    });
                    getModeByNamespace_1 = function (namespace) {
                        var mode = params.mode || DEFAULT_MODE;
                        if (!namespace || !params.modes) {
                            return mode;
                        }
                        var modeAtNamespace = params.modes && params.modes[editor_elements_conventions_1.withProdNamespace(namespace)];
                        return modeAtNamespace ? modeAtNamespace : mode;
                    };
                    eagerContexts = contexts.filter(function (context) {
                        return getModeByNamespace_1(context.library.namespace) === 'eager';
                    });
                    lazyContexts = contexts.filter(function (context) {
                        return getModeByNamespace_1(context.library.namespace) === 'lazy';
                    });
                    runLazyRegistry = function (hosts, props) {
                        if (!hosts.length) {
                            return;
                        }
                        var lazyRegistry = createLazyEntry_1.createLazyEntry({
                            contexts: hosts,
                            bundleLoaders: bundleLoaders_1,
                        });
                        return lazyRegistry(props);
                    };
                    runEagerRegistry = function (hosts, props) { return __awaiter(_this, void 0, void 0, function () {
                        var eagerRegistry;
                        return __generator(this, function (_a) {
                            if (!hosts.length) {
                                return [2 /*return*/];
                            }
                            eagerRegistry = createEagerEntry_1.createEagerEntry({
                                contexts: hosts,
                                bundleLoaders: bundleLoaders_1,
                            });
                            return [2 /*return*/, eagerRegistry(props)];
                        });
                    }); };
                    return [4 /*yield*/, Promise.all([
                            runLazyRegistry(lazyContexts, params),
                            runEagerRegistry(eagerContexts, params),
                        ])];
                case 3:
                    _a.sent();
                    return [2 /*return*/, getRegistryRuntime({ manifests: manifests })];
                case 4:
                    e_1 = _a.sent();
                    if (options.dev && !(e_1 instanceof RegistryError_1.RegistryError)) {
                        console.error("Registry Unexpected Exception \u2013 \"" + e_1.message + "\".\nPlease notify registry developers about this error.");
                    }
                    throw e_1;
                case 5: return [2 /*return*/];
            }
        });
    }); };
}
exports.createEntry = createEntry;
exports.default = createEntry;
//# sourceMappingURL=createEntry.js.map